import en from './en'
import es from './es'
import ca from './ca'

export default {
    en: en,
    es: es,
    ca: ca,
};

/* Text to translate */
/* 

$vuetify.lang.translator(key)



*/